<div class="form-card">
  <div class="form-details">
    <div class="pdf-icon">
      <img src="../../../../assets/images/pdfLogo.png" alt="">
    </div>
    <div class="form-content">
      <div class="form-name">{{document?.FileName}}</div>
      <!-- <div class="form-description">{{pdfDesc}}</div> -->
    </div>

  </div>
  <div class="action-icons">
    <div class="download-icon" (click)="downloadDocument()">
      <div class="download-form">
        <img src="../../../../assets/images/download-icon-black.png" alt="">
      </div>
    </div>
    <!-- <div class="share-icon">
        <img src="../../../../assets/images/share-icon-black.png" alt="">
      </div> -->
  </div>
</div>